<template>
  <div
    class="owal env ui row"
  >
    <div
      class="owal env ui text"
    >
      <div
        class="owal env ui title"
      >
        {{ title }}
      </div>
      <div
        class="owal env ui subtitle"
      >
        {{ subtitle }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnvRow',
  props: ['title', 'subtitle'],
}
</script>

<style scoped>

.owal.env.ui.row {
  display: flex;
  flex-direction: row;
  padding: 0.5rem 0 0.5rem 1.25rem;
  border-bottom: 1px solid #C0CCDA;
}

.owal.env.ui.text {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;
}

.owal.env.ui.toggle,
.owal.env.ui.effective {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.owal.env.ui.title {
  font-weight: bold;
}

.owal.env.ui.subtitle {
  color: #888;
  margin-left: 0.5rem;
}

</style>
